export default __webpack_public_path__ + "static/eraser_tool.c28a86f0c118e0dd13e25f57140ad093.svg";